import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-632c82f9"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "upload-area"
};
var _hoisted_2 = {
  class: "file-area"
};
var _hoisted_3 = {
  class: "file-detail"
};
var _hoisted_4 = {
  class: "file-name"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "点击查看", -1);
});
var _hoisted_6 = [_hoisted_5];
var _hoisted_7 = {
  key: 1,
  class: "upload-empty"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "upload-tips flex-align"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "icon-upload"
  }), /*#__PURE__*/_createTextVNode("点击上传 ")], -1);
});
var _hoisted_9 = {
  class: "file-tips"
};
var _hoisted_10 = {
  class: "file-area"
};
var _hoisted_11 = {
  class: "file-detail"
};
var _hoisted_12 = {
  class: "file-name"
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("i", {
    class: "icon-cancel"
  }, null, -1);
});
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "取消上传", -1);
});
var _hoisted_16 = [_hoisted_14, _hoisted_15];
var _hoisted_17 = ["onClick"];
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("i", {
    class: "icon-retry"
  }, null, -1);
});
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "重新上传", -1);
});
var _hoisted_20 = [_hoisted_18, _hoisted_19];
var _hoisted_21 = ["onClick"];
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("i", {
    class: "icon-warn"
  }, null, -1);
});
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "上传失败，请重新上传", -1);
});
var _hoisted_24 = [_hoisted_22, _hoisted_23];
var _hoisted_25 = {
  key: 0,
  class: "file-upload-progress"
};
var _hoisted_26 = ["accept"];
import { ref, computed, onUnmounted, watch } from 'vue';
import { CosService } from '@/services/cos.service';
import { CheatService } from '@/services/exam/cheat.service';
import { useService } from '@kaokei/use-vue-service';
import { uuid } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  props: {
    optionData: {
      type: Object,
      default: null
    },
    accept: {
      type: String,
      default: 'image/jpeg'
    },
    // 文件大小
    limitSize: {
      type: Number,
      // 0 标识不限制
      default: 0
    },
    // 视频时长大小判断
    limitDuration: {
      type: Number,
      // 0 标识不限制
      default: 0
    },
    // 答案url
    userAnswer: String,
    answerMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ['onUploaded'],
  setup: function (__props, _a) {
    var _this = this;
    var emits = _a.emit;
    var props = __props;
    var cosService = useService(CosService);
    var cheatService = useService(CheatService);
    var fileInputRef = ref(null);
    var showUpload = ref(true);
    var percent = ref(0);
    var status = ref('');
    var fileName = ref('');
    var taskIdTemp = ref('');
    var clientTemp;
    var doneTimer;
    var description = computed(function () {
      var optionData = props.optionData || {};
      var fileTypeLimitDesc = optionData.fileTypeLimitDesc,
        fileSizeLimitDesc = optionData.fileSizeLimitDesc,
        fileDurationLimitDesc = optionData.fileDurationLimitDesc;
      var desc = fileTypeLimitDesc || '';
      if (fileSizeLimitDesc) {
        desc = desc.concat("\uFF0C".concat(fileSizeLimitDesc));
      }
      if (fileDurationLimitDesc) {
        desc = desc.concat("\uFF0C".concat(fileDurationLimitDesc));
      }
      return desc;
    });
    watch(function () {
      return props.userAnswer;
    }, function (newVal) {
      if (newVal) {
        showUpload.value = false;
        status.value = 'done';
        fileName.value = decodeURIComponent(newVal.split('/').pop() || '');
      } else {
        showUpload.value = true;
        status.value = '';
      }
    }, {
      immediate: true
    });
    var handleUpload = function () {
      if (fileInputRef.value) {
        fileInputRef.value.click();
        percent.value = 0;
        cheatService.disable();
      }
    };
    var handleReUpload = function () {
      handleUpload();
    };
    var handleFileChange = function (event) {
      return __awaiter(_this, void 0, void 0, function () {
        var target, file, optionData, fileTypeLimitDesc, fileSizeLimitDesc, fileDurationLimitDesc, isValidType, isValidSize, isValidDuration, e_1, filePathAndName;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              target = event.target;
              cheatService.enable();
              if (!(target.files && target.files.length > 0)) return [3 /*break*/, 5];
              file = target.files[0];
              optionData = props.optionData || {};
              fileTypeLimitDesc = optionData.fileTypeLimitDesc, fileSizeLimitDesc = optionData.fileSizeLimitDesc, fileDurationLimitDesc = optionData.fileDurationLimitDesc;
              isValidType = checkFileType(file);
              if (!isValidType) {
                _message.error("".concat(fileTypeLimitDesc || ''));
                clearFileInput();
                return [2 /*return*/];
              }
              isValidSize = checkFileSize(file);
              if (!isValidSize) {
                _message.error("".concat(fileSizeLimitDesc || ''));
                clearFileInput();
                return [2 /*return*/];
              }
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              return [4 /*yield*/, checkVideoDuration(file)];
            case 2:
              isValidDuration = _a.sent();
              if (!isValidDuration) {
                _message.error("".concat(fileDurationLimitDesc || ''));
                clearFileInput();
                return [2 /*return*/];
              }
              return [3 /*break*/, 4];
            case 3:
              e_1 = _a.sent();
              _message.error('视频无法正常加载检测时长，请检查视频格式是否合法');
              clearFileInput();
              return [2 /*return*/];
            case 4:
              showUpload.value = false;
              status.value = 'uploading';
              fileName.value = file.name;
              filePathAndName = '';
              if (process.env.NODE_ENV === 'production') {
                filePathAndName = "/".concat(Date.now(), "/").concat(uuid(8), "/").concat(file.name);
              } else {
                filePathAndName = '/'.concat(file.name);
              }
              cosService.uploadBlob({
                blob: file,
                fileName: filePathAndName,
                cosType: 'appendix',
                onProgress: function (progress) {
                  percent.value = progress.percent * 100;
                  status.value = 'uploading';
                },
                onTaskReady: function (taskId, client) {
                  clearTimeout(doneTimer);
                  taskIdTemp.value = taskId;
                  clientTemp = client;
                },
                onError: function () {
                  status.value = 'error';
                  clearTimeout(doneTimer);
                  clearFileInput();
                },
                onSuccess: function (data) {
                  clearTimeout(doneTimer);
                  doneTimer = setTimeout(function () {
                    status.value = 'done';
                  }, 100);
                  clearFileInput();
                  var userAnswer = data.Location.startsWith('https') ? data.Location : 'https://'.concat(data.Location);
                  props.optionData.userAnswer = userAnswer;
                  emits('onUploaded', {
                    fileDescription: props.optionData.fileDescription,
                    fileDescriptionKey: props.optionData.fileDescriptionKey,
                    userAnswer: userAnswer
                  });
                }
              });
              _a.label = 5;
            case 5:
              return [2 /*return*/];
          }
        });
      });
    };
    var clearFileInput = function () {
      if (fileInputRef.value) {
        fileInputRef.value.value = '';
      }
    };
    var handleCancel = function () {
      if (taskIdTemp.value && clientTemp) {
        clientTemp.cancelTask(taskIdTemp.value);
        taskIdTemp.value = '';
        clientTemp = null;
        showUpload.value = true;
        status.value = '';
        percent.value = 0;
        clearFileInput();
      }
    };
    var checkFileType = function (file) {
      if (!props.accept) return true;
      var fileType = file.type;
      var validTypes = props.accept.split(',');
      return validTypes.includes(fileType);
    };
    var checkFileSize = function (file) {
      if (!props.limitSize) return true;
      var maxSize = props.limitSize;
      return file.size <= maxSize;
    };
    var checkVideoDuration = function (file) {
      var _a;
      if (!props.limitDuration || ((_a = props.optionData) === null || _a === void 0 ? void 0 : _a.fileTypeZh) !== '视频') {
        return Promise.resolve(true);
      }
      var video = document.createElement('video');
      video.preload = 'metadata';
      video.muted = true;
      video.src = URL.createObjectURL(file);
      return new Promise(function (resolve, reject) {
        video.onloadedmetadata = function () {
          var duration = video.duration;
          resolve(duration <= props.limitDuration);
        };
        video.onerror = function () {
          reject(false);
        };
      });
    };
    var handlePreview = function () {
      if (props.userAnswer) {
        window.open(props.userAnswer);
      }
    };
    onUnmounted(function () {
      clearTimeout(doneTimer);
    });
    return function (_ctx, _cache) {
      var _a, _b, _c, _d, _e, _f;
      var _component_a_progress = _resolveComponent("a-progress");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["file-upload-com", {
          'file-upload-com-bgwhite': !__props.answerMode
        }])
      }, [__props.answerMode ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [props.optionData.userAnswer ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["file-icon", {
          'icon-pic': ((_a = props.optionData) === null || _a === void 0 ? void 0 : _a.fileTypeIcon) === 'pic',
          'icon-video': ((_b = props.optionData) === null || _b === void 0 ? void 0 : _b.fileTypeIcon) === 'video',
          'icon-pdf': ((_c = props.optionData) === null || _c === void 0 ? void 0 : _c.fileTypeIcon) === 'pdf'
        }])
      }, null, 2), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(fileName.value), 1), _createElementVNode("div", {
        class: "file-status",
        onClick: handlePreview
      }, _hoisted_6)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, "- 未上传 -"))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [showUpload.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "upload-before",
        onClick: handleUpload
      }, [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(description)), 1)])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["upload-area", {
          'upload-area-error': status.value === 'error'
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["file-icon", {
          'icon-pic': ((_d = props.optionData) === null || _d === void 0 ? void 0 : _d.fileTypeIcon) === 'pic',
          'icon-video': ((_e = props.optionData) === null || _e === void 0 ? void 0 : _e.fileTypeIcon) === 'video',
          'icon-pdf': ((_f = props.optionData) === null || _f === void 0 ? void 0 : _f.fileTypeIcon) === 'pdf'
        }])
      }, null, 2), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(fileName.value), 1), status.value === 'uploading' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "file-status",
        onClick: _withModifiers(handleCancel, ["stop"])
      }, _hoisted_16, 8, _hoisted_13)) : _createCommentVNode("", true), status.value === 'done' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "file-status",
        onClick: _withModifiers(handleReUpload, ["stop"])
      }, _hoisted_20, 8, _hoisted_17)) : _createCommentVNode("", true), status.value === 'error' ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "file-status",
        onClick: _withModifiers(handleReUpload, ["stop"])
      }, _hoisted_24, 8, _hoisted_21)) : _createCommentVNode("", true)]), status.value === 'uploading' ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_a_progress, {
        percent: percent.value,
        "show-info": false,
        "stroke-color": "#ff5f00"
      }, null, 8, ["percent"])])) : _createCommentVNode("", true)])], 2))], 64)), _createElementVNode("input", {
        type: "file",
        accept: __props.accept,
        style: {
          "display": "none"
        },
        ref: function (_value, _refs) {
          _refs['fileInputRef'] = _value;
          fileInputRef.value = _value;
        },
        onChange: handleFileChange
      }, null, 40, _hoisted_26)], 2);
    };
  }
});